import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

export const getDeveloperMode = async (
  editorSdkProxy: EditorSDK,
): Promise<boolean> => {
  // workaround due to ADI and Editor3 platform implementation missing developerMode namespace
  try {
    return await editorSdkProxy.editor.developerMode.isEnabled()
  } catch {
    return false
  }
}
